var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_component-button",
      class: _vm.componentClassObj,
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.handleClick.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "button-content" },
        [
          _vm._t("default"),
          _vm.subText
            ? _c("div", { staticClass: "sub-text" }, [
                _vm._v(_vm._s(_vm.subText))
              ])
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }